<div class="vh-100 p-4 bg-logo-white">
  <div class="d-flex gap-3 align-items-center mb-4">
    <button (click)="lang.toggleLanguage()" type="button" class="btn lang-btn bg-info-o rounded-8">
      <i class="fa-solid fa-globe"></i>
    </button>
  </div>
  <img src="assets/images/logo3.png" height="70" alt="" srcset="" />

  <h3 class="mt-5 fw-600" translate="sorry_refused"></h3>
  <p class="text-info fs-5" translate="review_your_app"></p>
  <br>

  <div>
    <h3 class="fw-500" translate="reject_reason"></h3>
    <p class="text-info fs-5 mt-0" *ngFor="let item of reason">{{item.reason}}</p>
  </div>
  <button type="button" class="btn btn-primary px-4 py-2 mt-5 rounded-10" translate="logout"
    (click)="logout()"></button>
</div>
